import type {
  AutoBidIntradayDraftError,
  AutoBidValidationError,
} from '~/pages/AdminApprovalFlow/models/autoBid'

/**
 * 自動入札ルール編集モーダル (スポット / 時間前) の範囲エラー種別 → i18n key。
 *
 * price は AC-BSP-078 の共通文言、 adjustment は専用文言 (enechain/ebalance#7640)。
 * key は動的組み立てにせず実キーを書き出す (= i18n key の grep / 未使用検出を効かせる。
 * 先行例: SpotBidding/components/BidFormAlerts.tsx の JEPX_MESSAGE)。
 */
export const AUTO_BID_VALIDATION_MESSAGE_KEY: Record<
  AutoBidValidationError,
  string
> = {
  price: 'page:biddingCommon.validation.priceRange',
  adjustment: 'page:adminApprovalFlow.autoBid.validation.adjustment',
}

/** 時間前入札の自動入札ルール編集モーダルで保存を拒否する理由 → i18n key (AC-APF-076)。 */
export const AUTO_BID_INTRADAY_DRAFT_ERROR_MESSAGE_KEY: Record<
  AutoBidIntradayDraftError,
  string
> = {
  basisRequired: 'page:adminApprovalFlow.autoBid.validation.basisRequired',
}
